export const venueConfigQueryKey = (venueId: string | undefined) =>
  ["venueConfig", venueId] as const;

export const venuesQueryKey = (venueGroupId: string | undefined) =>
  ["venues", venueGroupId] as const;
